import { send } from 'server';

export const SET_FEED = 'SET_FEED';
export const SET_CATEGORIES = 'SET_CATEGORIES';
export const SET_FILTERED_CATEGORIES = 'SET_FILTERED_CATEGORIES';
export const SET_RECENTLY_PLAYED = 'SET_RECENTLY_PLAYED';
export const UPDATE_RECENTLY_PLAYED_IS_LOADING = 'GAMES:RECENTLY_PLAYED_IS_LOADING:UPDATE';
export const GAMES_PUSH = 'GAMES_PUSH';
export const DYNAMIC_CATEGORIES_FETCHED = 'DYNAMIC_CATEGORIES_FETCHED';
export const SET_EXPANDED_CATEGORY = 'SET_EXPANDED_CATEGORY';
export const SET_SEARCH_ACTIVE = 'SET_SEARCH_ACTIVE';
export const SET_IMAGES_LOADED = 'SET_IMAGES_LOADED';
export const UPDATE_LIVE_LAUNCH_ALIASES = 'GAMES:LIVE_LAUNCH_ALIASES:UPDATE';

export const getRecentlyPlayed = () => send({
    ID: 35547,
    tagName: 'uam/hidden/playerRecentGames',
    description: 'get recently played games',
    responses: [35548, 35549]
});

export const setFeedAction = ({ feedName, feed }) => ({
    type: SET_FEED,
    payload: { feedName, feed }
});

export const setCategoriesAction = categories => ({
    type: SET_CATEGORIES,
    payload: categories
});

export const setFilteredCategoriesAction = filteredCategories => ({
    type: SET_FILTERED_CATEGORIES,
    payload: filteredCategories
});

export const setRecentlyPlayedAction = gamesCodes => ({
    type: SET_RECENTLY_PLAYED,
    payload: { gamesCodes }
});

export const updateRecentlyPlayedIsLoading = isLoading => ({
    type: UPDATE_RECENTLY_PLAYED_IS_LOADING,
    payload: isLoading
});

export const gamesPushAction = payload => ({
    type: GAMES_PUSH,
    payload
});

export const dynamicCategoriesFetchedAction = data => ({
    type: DYNAMIC_CATEGORIES_FETCHED,
    payload: data
});

export const setExpandedCategoryAction = cid => ({
    type: SET_EXPANDED_CATEGORY,
    payload: cid
});

export const setSearchActiveAction = isActive => ({
    type: SET_SEARCH_ACTIVE,
    payload: isActive
});

export const setImagesLoadedAction = () => ({
    type: SET_IMAGES_LOADED
});

export const updateLiveLaunchAliases = (liveLaunchAliases) => ({
    type: UPDATE_LIVE_LAUNCH_ALIASES,
    payload: liveLaunchAliases
});
